import { BrandService } from '@/services';
import { BrandType, RootModel } from '@/types';
import { createModel } from '@rematch/core';
import baseEntity from './base.entity';

interface BrandStateType {
  ids: { [id: number]: BrandType };
}

export const brandEntities = createModel<RootModel>()({
  state: { ids: {} } as BrandStateType,
  reducers: {
    ...baseEntity,
  },
  effects: () => ({
    async findByUser(): Promise<BrandType | null> {
      const res = await BrandService.getByUser();
      if (res.data) {
        this.saves([res.data]);
      }
      return res.data;
    },
    async save(payload) {
      let item;
      if (!payload?.id) {
        ({ data: item } = await BrandService.create(payload));
      } else {
        ({ data: item } = await BrandService.update(payload.id, payload));
      }
      this.update(item);
      return item;
    },
  }),
});
